import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Entry_type } from '../models/entry_type';
import { Entry_type_bill_template_map } from '../models/entry_type_bill_template_map';
import { Entry_type_section_map } from '../models/entry_type_section_map';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class EntryTypeService {

  constructor(private http: HttpClient) { }

  get(horse_show_id: string, entry_type_number: number): Promise<Entry_type> {
  	return this.getWithRest('horse_show_id/' + horse_show_id + '/number/' + entry_type_number);
  }

  private getWithRest(rest_url: string) : Promise<Entry_type> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'entry_types/' + rest_url).subscribe((response:any) => {
			if(response.type == 'entry_type' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error => {
				if(error instanceof HttpErrorResponse){
            	  reject(error.error);
            	} else {
            		reject(error);
            	}
			});
	});
  }

  getListByHorseShow(horse_show_id: string): Promise<Entry_type[]> {
	return this.getListWithRest('horse_show_id/' + horse_show_id);
  }

  getListByHorseShowAndDiscipline(horse_show_id: string, discipline: string): Promise<Entry_type[]> {
	return this.getListWithRest('horse_show_id/' + horse_show_id + '/discipline/' + discipline);
  }

  private getListWithRest(rest_url: string) : Promise<Entry_type[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'entry_types/' + rest_url).subscribe((response:any) => {
			if(response.type == 'entry_types' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error => {
				if(error instanceof HttpErrorResponse){
					if(error.status == 404){
						resolve([]);
					} else {
            	  reject(error.error);
					}
            	} else {
            		reject(error);
            	}
			});
	});
  }



}
